/**
 * AudioKeyboardHandler Component
 * 
 * Handles global keyboard shortcuts for audio control.
 * - M: Toggle mute
 */

import { useEffect } from 'react';
import { audioManager } from '../audio/AudioManager.js';

export function AudioKeyboardHandler() {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Ignore if typing in an input
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      // M key toggles mute
      if (event.key === 'm' || event.key === 'M') {
        audioManager.toggleMute();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return null; // No visual output
}

export default AudioKeyboardHandler;
